import classNames from 'classnames'
import Image from 'next/legacy/image'
import Button from 'react-bootstrap/Button'
import useThriveAuth from 'hooks/useThriveAuth'
import styles from './index.module.scss'
import { dateFormats } from 'constants/common'
import { SlotAvailabilityType } from 'app/Bookings/constants'
import { availabilityIconMapping } from 'app/ProviderSearch/constants'
import { useContext } from 'react'
import { TimeZoneContext } from 'context/common/TimeZoneContext'

type SlotGridButtonProps = {
  buttonVariant?: string
  slotButtonClass?: string
  slot: ProviderSlot
  onSlotClick: () => void
  showSlotAvailabilityIcon: boolean
  slotAvailabilities?: SlotAvailabilityType[]
  isProviderPage?: boolean
}

const SlotGridButton: React.FC<SlotGridButtonProps> = ({
  buttonVariant = '',
  slotButtonClass = '',
  slot,
  onSlotClick,
  showSlotAvailabilityIcon,
  slotAvailabilities,
  isProviderPage = false,
}) => {
  const { format } = useContext(TimeZoneContext)
  const { isSupportOrThirdPartyUser } = useThriveAuth()

  const getSlotBtnText = (start: string | number) => {
    const slotBtnText = format(
      new Date(start),
      dateFormats.TIME_FORMAT
    ).toLowerCase()

    const slotBtnTextHourFormat = slotBtnText.replace(/:00/g, '')

    return slotBtnTextHourFormat
  }

  return (
    <Button
      variant={buttonVariant}
      className={classNames(styles.slot_button, slotButtonClass)}
      onClick={onSlotClick}
    >
      {getSlotBtnText(slot.start)}
      {(isSupportOrThirdPartyUser || showSlotAvailabilityIcon) && (
        <div
          className={classNames(styles.slot_availability, 'd-flex', {
            'mt-1': !isProviderPage && showSlotAvailabilityIcon,
          })}
        >
          {slotAvailabilities.map((slotAvailability) => (
            <div
              key={slotAvailability}
              className="d-flex justify-content-start"
            >
              <Image
                src={availabilityIconMapping[slotAvailability]}
                alt={slotAvailability}
                height={isProviderPage ? '10' : '14'}
                width={isProviderPage ? '10' : '14'}
                unoptimized
              />
            </div>
          ))}
        </div>
      )}
    </Button>
  )
}

export default SlotGridButton
